import React from 'react';
import EnableMFARouteV2 from './V2/EnableMFARouteV2';

const AgentEnableMFARouteV2: React.FC = () => {
  return <EnableMFARouteV2 />;
};

export default AgentEnableMFARouteV2;
